import React from "react";
import { useRouter } from "next/router";

export const Footer: React.FC<{}> = () => {
  const history = useRouter();
  return (
    <div className="grid grid-cols-1  lg:grid-cols-3 gap-y-10 lg:px-32 md:px-20 pt-14 pb-20 md:pb-6 bg-black text-white font-semibold  items-start ">
      <div className=" text-white flex flex-col items-start ml-6 ">
        <h2 className="font-bold text-white text-lg items-start">Help</h2>
        <div className=" grid lg:grid-cols-4 lg:flex lg:flex-col  justify-between lg:justify-start lg:space-y-4">
          <p className="cursor-pointer hover:text-white hover:underline">
            FAQ & Tutorials (Coming Soon)
          </p>
          <p className="cursor-pointer hover:text-white hover:underline">
            Suggestions & Bugs (Coming Soon)
          </p>
        </div>
      </div>

      <div className="flex flex-col text-white items-start ml-6">
        <h2 className="font-bold text-white text-lg">Project</h2>
        <div className="grid lg:grid-cols-4 lg:flex lg:flex-col  justify-between lg:justify-start lg:space-y-4">
          <p
            className="cursor-pointer hover:text-white hover:underline"
            onClick={() =>
              window.open("mailto: luis.egvillarreal@gmail.com?subject=Contact")
            }
          >
            About Project (Coming Soon)
          </p>

          <p className="cursor-pointer hover:text-white hover:underline">
            Pricing (Coming Soon)
          </p>
        </div>
      </div>
      <div className="flex flex-col text-white items-start ml-6">
        <h2 className="font-bold text-white text-lg">Future Services</h2>
        <div className="grid lg:grid-cols-4 lg:flex lg:flex-col  justify-between lg:justify-start lg:space-y-4">
          <p className="cursor-pointer hover:text-white hover:underline">
            API (Coming Soon)
          </p>
          <p className="cursor-pointer hover:text-white hover:underline">
            Public Projects (Coming Soon)
          </p>
        </div>
      </div>
      <div className="col-span-3 lg:flex-row border-t-white border-t-2 border-opacity-20 py-2 text-center  ">
        <div className="flex flex-col text-center lg:flex-row space-x-4 text-white">
          <p className="font-semibold">
            <i className="far fa-copyright" /> Universal Graph - Created in 2022
            by{" "}
            <a
              href="https://github.com/LuisEGV"
              className="hover:text-blue-400 hover:cursor-pointer"
            >
              Luis Gonzalez 🌊
            </a>
          </p>
          <div className="flex flex-row space-x-4">
            <p
              className="cursor-pointer hover:text-white hover:underline"
              onClick={() => history.push("/privacypolicy")}
            >
              Privacy Policy (Coming Soon)
            </p>
            <p>-</p>
            <p
              onClick={() => history.push("/terms")}
              className="cursor-pointer hover:text-white hover:underline"
            >
              Terms and Conditions (Coming Soon)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
